import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AuthenticationService, Verify2FaRequest } from '@b3networks/api/auth';
import { delay, finalize } from 'rxjs';
import { ToastService } from '@b3networks/shared/ui/toast';
import { Router } from '@angular/router';

export enum SignupEmailState {
  'InputEmail' = 'InputEmail',
  'InputCode' = 'InputCode',
  'Exist' = 'Exist'
}

export enum SpinnerType {
  'Verifying' = 'verifying',
  'Resending' = 'resending'
}

@Component({
  selector: 'b3n-signup-email',
  templateUrl: './signup-email.component.html',
  styleUrls: ['./signup-email.component.scss']
})
export class SignupEmailComponent {
  readonly SignupEmailState = SignupEmailState;
  readonly SpinnerType = SpinnerType;

  @Input() redirectUrl: string;
  @Output() backEvent: EventEmitter<void> = new EventEmitter<void>();

  emailCtrl = new FormControl(null, [Validators.required, Validators.email]);
  codeCtrl = new FormControl(null, [Validators.required]);

  otpId: string;
  sanitizedCode: string;
  state = SignupEmailState.InputEmail;

  spinner: { [key in SpinnerType]: boolean } = {
    [SpinnerType.Resending]: false,
    [SpinnerType.Verifying]: false
  };

  constructor(
    private authenticationService: AuthenticationService,
    private toastService: ToastService,
    private router: Router
  ) {}

  verifyEmail(type: SpinnerType) {
    this.spinner[type] = true;
    this.authenticationService
      .verifySignupEmail(this.emailCtrl.value)
      .pipe(finalize(() => (this.spinner[type] = false)))
      .subscribe({
        next: value => {
          this.otpId = value.otpId;
          this.sanitizedCode = value.sanitizedCode;
          this.state = SignupEmailState.InputCode;
        },
        error: error => {
          console.error(error);
          if (error && error.message === 'email exists') {
            this.state = SignupEmailState.Exist;
          } else {
            this.toastService.error(error?.message);
          }
        }
      });
  }

  verify2FA() {
    this.spinner[SpinnerType.Verifying] = true;
    const req = {
      otpId: this.otpId,
      otpCode: this.sanitizedCode + '-' + this.codeCtrl.value?.trim()
    } as Verify2FaRequest;

    this.authenticationService
      .verifySignup2FA(req)
      .pipe(
        delay(500),
        finalize(() => (this.spinner[SpinnerType.Verifying] = false))
      )
      .subscribe({
        next: resp => {
          this._redirect2CreateOrg(resp.sid);
        },
        error: error => {
          this.toastService.error(error?.messge);
        }
      });
  }

  back() {
    this.backEvent.emit();
  }

  navigate2Login() {
    this.router.navigate(['auth', 'login'], {
      queryParamsHandling: 'merge',
      queryParams: this.emailCtrl.value && this.emailCtrl.valid ? { email: this.emailCtrl.value } : null
    });
  }

  _redirect2CreateOrg(state: string) {
    let url = `${location.origin}/redeem/#/create-org?state=${state}&email=${this.emailCtrl.value}`;
    if (this.redirectUrl) {
      url += `&redirectUrl=${encodeURIComponent(this.redirectUrl)}`;
    }

    window.location.replace(url);
  }
}
